import { Chip, Text } from "designSystem/index";
import React from "react";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";

export default () => (
	<CssColumnGrid columns={4}>
		<Text semiBold text="default" />
		<Text semiBold text="outlined" />
		<Text semiBold text="default and deletable" />
		<Text semiBold text="outlined deletable" />
		<Chip
			disabled
			label="default"
		/>
		<Chip
			disabled
			label="outlined"
			variant="outlined"
		/>
		<Chip
			disabled
			label="default and deletable"
			onDelete={() => { console.log("clickable"); }}
		/>
		<Chip
			disabled
			label="outlined deletable"
			onDelete={() => { console.log("clickable"); }}
			variant="outlined"
		/>
	</CssColumnGrid>
);